import React from "react";

import UploadButton from "./UploadButton";

const Intro = ({ onShowUploadModal }) => {
  return (
    <div className="tool__intro">
      <h4 className="tool__header">Your Art</h4>
      <UploadButton onShowUploadModal={onShowUploadModal} />
      <p>
        The following file types are IDEAL for printing: vector AI, PDF, and
        EPS. We can also accept high resolution PNG and JPG Files. The file can
        be up to 8 MB in size.
      </p>
      <p>
        Please make sure your artwork is in black and white (no shades of gray).
        White artwork on a white background will not appear in the preview. Make
        sure fonts are embedded/outlined.
      </p>
      <p>
        Please note: uploading custom artwork/logo incurs a $50 custom art
        charge. This includes a thorough review of your file as well as any
        necessary editing to ensure legibility and accuracy on printed
        product(s). This fee covers the use of one unique design on up to 2
        differing products, and is refunded upon verification of the same
        artwork by a designer after you place your order with any re-order using
        the same artwork within 9 months. A proofing process with an in-house
        designer is also an available option prior to printing. More details can
        be found in our{" "}
        <a href="/faq" target="_blank">
          FAQs
        </a>
        .
      </p>
    </div>
  );
};

export default Intro;
